import React from "react";
import { Text, VStack, HStack } from "@sqymagma/elements";

import { User } from "@types";
import { WidgetBox } from "@components";
import { Avatar, Icon } from "@elements";
import Chart from "./Chart";
import { isDateWithinRange } from "@helpers";
import { christmasRange } from "@config";
interface Props {
  steps: Array<number>;
  user: User | null;
}

const UserWidget = (props: Props) => {
  const { steps, user } = props;
  steps.unshift(...Array(7 - steps.length).fill(0));

  const lastWeekSteps = steps[steps.length - 2];
  const thisWeekSteps = steps[steps.length - 1];
  const motivationalMessage = !thisWeekSteps
    ? "No subestimes ningún paso. ¡Añádelos!"
    : !lastWeekSteps
    ? "¡Enhorabuena por tus primeros pasos!"
    : 70000 - thisWeekSteps >= 1 && 70000 - thisWeekSteps <= 5000
    ? "¡Estás muy cerca de la división Guepardo!"
    : 40000 - thisWeekSteps >= 1 && 40000 - thisWeekSteps <= 5000
    ? "¡Estás muy cerca de la división Gacela!"
    : thisWeekSteps - lastWeekSteps > 1000
    ? `¡Has dado ${(
        thisWeekSteps - lastWeekSteps
      ).toLocaleString()} pasos más que la semana anterior!`
    : thisWeekSteps - lastWeekSteps >= -1000
    ? "¡Genial¡ Te mantienes en tu línea"
    : "Menos pasos, ¡pero siempre en marcha!";

  const labels = Array.from({ length: 7 }, (_, i) => {
    const now = new Date();
    const lastWeek = new Date(now);
    lastWeek.setDate(now.getDate() - 7);
    const startOfWeek = new Date(
      lastWeek.setDate(
        lastWeek.getDate() - ((lastWeek.getDay() + 6) % 7) - (6 - i) * 7
      )
    );
    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 6);

    const formatDate = (date: Date) =>
      date.toLocaleDateString("es-ES", {
        day: "numeric",
        month: "short",
      });

    return startOfWeek.getMonth() === endOfWeek.getMonth()
      ? `${startOfWeek.getDate()} - ${formatDate(endOfWeek)}`
      : `${formatDate(startOfWeek)} - ${formatDate(endOfWeek)}`;
  });

  return (
    <WidgetBox bg="secondaryBackground">
      {isDateWithinRange(new Date(), christmasRange) && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: "-10%",
            width: "120%",
            transform: "translateY(-54%)",
          }}
        >
          <Icon name="camelsEspumillon" />
        </div>
      )}

      <HStack gap="xs" mb="xs">
        <Avatar image={user?.image} size="xl" border="gray" />
        <VStack gap="xxxs">
          <Text
            textStyle="headingxs"
            style={{ textTransform: "uppercase" }}
            color="text02"
          >
            Mis pasos
          </Text>
          <Text
            textStyle="display02"
            style={{ fontWeight: 800 }}
            color="text02"
          >
            {thisWeekSteps.toLocaleString()}
          </Text>
          {(lastWeekSteps || !thisWeekSteps) && (
            <Text textStyle="body" style={{ fontWeight: 800 }} color="text03">
              {!thisWeekSteps
                ? "Sin registro"
                : `${lastWeekSteps.toLocaleString()} pasos la semana anterior`}
            </Text>
          )}
          <Text
            textStyle="bodyInline"
            style={{ fontWeight: 800 }}
            color="brand01"
          >
            {motivationalMessage}
          </Text>
        </VStack>
      </HStack>

      <Chart datasets={[{ data: steps }]} labels={labels} />
    </WidgetBox>
  );
};

export default UserWidget;
